if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

Element.prototype.remove = function () {
  try {
    this.parentElement.removeChild(this);
  } catch{ }
}

import cssVars from 'css-vars-ponyfill';
cssVars();

import Vue from "vue";
import App from "./App.vue";

import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";
Vue.use(Vuesax);

import VueKonva from "vue-konva";
Vue.use(VueKonva);

import VueCookies from "vue-cookies";
VueCookies.config("7d");

Vue.use(VueCookies);

import axios from "axios";
Vue.prototype.$http = axios;

import "../themeConfig.js";

import InstantSearch from "vue-instantsearch";
Vue.use(InstantSearch);

import AuthPlugin from "./plugins/auth";
//import SignalRPlugin from "./plugins/signalr";
import MiscPlugin from "./plugins/misc";
Vue.use(AuthPlugin);
//Vue.use(SignalRPlugin);
Vue.use(MiscPlugin);

import "./globalComponents.js";

import "./assets/scss/main.scss";
import "@/assets/css/main.css";

import router from "./router";
import store from "./store/store";
import i18n from "./i18n/i18n";

import "./filters/filters";

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VueTour from "vue-tour";
Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

import { extend, configure } from "vee-validate";
import { length, numeric, digits, required, email, min, max, min_value } from "vee-validate/dist/rules";

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

var currencyGlobalOptions = {
  globalOptions: {
    "distraction-free": "hideCurrencySymbol",
    currency: {
      prefix: "₺ "
    },
    locale: "tr-TR",
  }
};

import VueCurrencyInput from 'vue-currency-input'
import { parse } from 'vue-currency-input'

Vue.use(VueCurrencyInput, currencyGlobalOptions);

var cardValid = require('card-validator');

import IBAN from "iban";
extend("numeric", numeric);
extend("digits", digits);
extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("length", length);
extend("min_value", min_value);

extend("min_value_currency", {
  validate: function (value, args) {
    var input = parse(value, currencyGlobalOptions.globalOptions);
    return input >= 1.00;
  }
});

extend("plaka", {
  validate: function (value, args) {
    var regex, v;
    v = value.replace(/\s+/g, "").toUpperCase();

    regex = /^(0[1-9]|[1-7][0-9]|8[01])(([A-Z])(\d{4,5})|([A-Z]{2})(\d{3,4})|([A-Z]{3})(\d{2,3}))$/;

    return v.match(regex) != null;
  }
});

extend("ccnumber", {
  validate: function (value, args) {
    var v = value.replace(/\D/g, "");
    value = value.replace(/\D/g, "");
    var maxLength = 0;

    if (/^3[47]\d{0,13}$/.test(value)) {
      value = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
      maxLength = 17;
    } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
      value = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
      maxLength = 16;
    }
    else if (/^9792\d{0,12}$/.test(value)) {
      value = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
        .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
      maxLength = 19; 
      return value.length == maxLength;
    } else if (/^\d{0,16}$/.test(value)) {
      value = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
        .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
      maxLength = 19;
    } 
    var numberValidation = cardValid.number(v);
     
    return value.length == maxLength && numberValidation.isPotentiallyValid;
  }
});

extend("identityNumber", {
  validate: function (value, args) {
    var regex, v;
    v = value.replace(/\s+/g, "").toUpperCase();

    regex = /^[1-9]{1}[0-9]{10}$/; 

    return v.match(regex) != null;
  }
});

extend("iban", {
  validate: function (value, args) {
    return IBAN.isValid(value);
  }
});

import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
